import React from "react";
import DataTable from "../../../components/data-table";
import AddPost from "./add-post";
import {
  columns,
  egTaggedFilter,
  postsFilterStatus,
  reportsFilterOption,
  userRoles,
} from "./constant";
import { usePosts } from "./hooks";
import DateRangeFilter from "../../../components/filters/date-range-filter";
import SearchFilter from "../../../components/filters/search-filter";
import SelectFilter from "../../../components/filters/select-filter";
import { Tooltip } from "@material-ui/core";
import UnpublishPost from "./unpublish-post";
import { useHistory } from "react-router-dom";
import EditPost from "./edit-post";
import DeletePost from "./delete-post";
import moment from "moment";
import ShareList from "./components/shared-list";
import ExportComponent from "./export";
import PostCaption from "./components/post-caption";
import { TABLE_CAPTION_CHAR_LENGTH } from "../../../constants";
import ConfidenceScore from "../../../components/confidence-score";

const Posts = (props) => {
  const {
    filters,
    setFilter,
    resetFilter,
    posts,
    count,
    user,
    updatePostsStatus,
    loadingPosts,
    isAdmin,
    hashtagClick,
    handleReportClick,
  } = usePosts(props);

  const history = useHistory();
  const configureTableData = () => {
    try {
      let results = posts.map((post) => {
        let newPost = Object.assign({}, post);
        newPost["caption"] = post?.caption ? (
          <PostCaption
            className="mentioned_data"
            captionText={post?.caption}
            ranges={post?.ranges}
            hashtagClick={hashtagClick}
            charLength={TABLE_CAPTION_CHAR_LENGTH}
          />
        ) : (
          "NA"
        );
        newPost["topic"] = post?.poll?.topic ? (
          <p className="poll_question">{post?.poll?.topic}</p>
        ) : (
          "NA"
        );
        newPost["share_count"] = <ShareList post={post} />;
        newPost["reports"] = post?.stats?.reports_count ? (
          <Tooltip title="View Reports">
            <span
              id={post?.id}
              className="schedule__booked-info"
              onClick={handleReportClick}
            >
              {post?.stats?.reports_count}{" "}
              {post?.stats?.reports_count > 1 ? "reports" : "report"}
            </span>
          </Tooltip>
        ) : (
          "NA"
        );
        newPost["created_at"] = moment(post?.created_at).format(
          "DD/MM/YYYY @ hh:mm A"
        );
        newPost["updated_at"] = moment(post?.updated_at).format(
          "DD/MM/YYYY @ hh:mm A"
        );
        newPost["reason"] = post?.reason || "NA";

        newPost["choices"] = post?.poll?.poll_choices?.length
          ? post?.poll?.poll_choices?.map((choice) => choice?.title)?.join(", ")
          : "NA";
        newPost["name"] = post?.owner?.name || "NA";
        newPost["action"] = (
          <div className="d-flex justify-content-start">
            <ConfidenceScore
              data={post}
              trackableType="POST"
              className="mr-3"
            />
            <Tooltip
              title="View"
              placement="bottom"
              className="view_user_details_pad_left10 mr-3"
            >
              <i
                className={`fa fa-eye icon-btn-action `}
                onClick={() =>
                  history.push({
                    pathname: `/post/${post?.id}`,
                  })
                }
              ></i>
            </Tooltip>
            {isAdmin && (
              <div className="mr-3">
                <UnpublishPost
                  handleSubmit={updatePostsStatus}
                  data={post}
                  status={post?.status}
                />
              </div>
            )}
            {!post?.poll?.topic && user?.user?.id === post?.created_by && (
              <EditPost post={post} />
            )}
            {user?.user?.id === post?.created_by && <DeletePost post={post} />}
          </div>
        );

        return newPost;
      });
      const reactTableData = {
        tableHeaderData: columns,
        tableRowsData: results,
      };
      return reactTableData;
    } catch (err) {
      console.error(err);
    }
  };

  const postsFilter = () => (
    <>
      <div className="d-flex flex-column">
        <div className="d-flex">
          <DateRangeFilter
            handleChange={setFilter}
            selectedValue={filters.created_at}
            filterKey="created_at"
            filterTitle="Published Date"
          />
          <SearchFilter
            handleSearch={setFilter}
            searchPlaceholder="User ID"
            filterKey="user_id"
            filterTitle="User ID"
            searchedValue={filters.user_id}
          />
          <SearchFilter
            handleSearch={setFilter}
            searchPlaceholder="Username"
            filterKey="name"
            filterTitle="Username"
            searchedValue={filters.name}
          />
          <SearchFilter
            handleSearch={setFilter}
            searchPlaceholder="Caption"
            filterKey="caption"
            filterTitle="caption"
            searchedValue={filters.caption}
          />
          <SearchFilter
            handleSearch={setFilter}
            searchPlaceholder="Hashtag"
            filterKey="hashtag"
            filterTitle="Hashtag"
            searchedValue={filters.hashtag}
          />
          <SelectFilter
            handleSelect={setFilter}
            selectedValue={filters.status}
            filterKey="status"
            options={postsFilterStatus}
            defaultOption="All"
            filterTitle="Status"
          />
        </div>

        <div className="d-flex mt-2">
          <SearchFilter
            handleSearch={setFilter}
            searchPlaceholder="Event or Course Tagged"
            filterKey="event_title"
            filterTitle="Event or Course Tagged"
            searchedValue={filters.event_title}
          />

          <SearchFilter
            handleSearch={setFilter}
            searchPlaceholder="Poll Question"
            filterKey="poll_question"
            filterTitle="Poll Question"
            searchedValue={filters.poll_question}
          />

          <SearchFilter
            handleSearch={setFilter}
            searchPlaceholder="Mobile Number"
            filterKey="mobile_number"
            filterTitle="Mobile Number"
            searchedValue={filters.mobile_number}
          />

          <SelectFilter
            handleSelect={setFilter}
            selectedValue={filters.evergreen_club_tagged}
            filterKey="evergreen_club_tagged"
            options={egTaggedFilter}
            filterTitle="EG Tagged"
          />
          <SelectFilter
            handleSelect={setFilter}
            selectedValue={filters.reported}
            filterKey="reported"
            options={reportsFilterOption}
            filterTitle="Reported Posts"
            defaultOptionValue={false}
          />

          <SelectFilter
            handleSelect={setFilter}
            selectedValue={filters.roles}
            filterKey="roles"
            options={userRoles}
            defaultOption="All Roles"
            filterTitle="Roles"
          />
        </div>
      </div>
      <Tooltip title="Clear filters" placement="bottom">
        <div className="filter__reset-all" onClick={resetFilter}>
          <i className="fa fa-filter filter-icon"></i>
          <i className="fa fa-times-circle remove-icon"></i>
        </div>
      </Tooltip>
    </>
  );

  return (
    <DataTable
      title="Posts"
      addBtn={
        <div className="d-flex">
          <AddPost />
          <ExportComponent />
        </div>
      }
      searchPlaceholder="Search Post"
      CreateTableData={configureTableData}
      withFilter={true}
      filter={postsFilter}
      handleSetFilter={setFilter}
      count={count}
      skip={filters?.skip}
      isLoading={loadingPosts}
    />
  );
};

export default Posts;
